"use strict";

var _classCallCheck = require("C:\\Users\\jc524\\dev\\voxelviewer\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\jc524\\dev\\voxelviewer\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 *
 */

var Visitor = /*#__PURE__*/function () {
  function Visitor() {
    _classCallCheck(this, Visitor);
  }

  _createClass(Visitor, [{
    key: "onSurfaceMount",

    /**
     *
     */
    value: function onSurfaceMount(surface) {}
    /**
     *
     */

  }, {
    key: "onSurfaceUnmount",
    value: function onSurfaceUnmount(surface) {}
    /**
     *
     */

  }, {
    key: "onSurfaceGLContextChange",
    value: function onSurfaceGLContextChange(surface, gl) {}
    /**
     */

  }, {
    key: "onSurfaceDrawSkipped",
    value: function onSurfaceDrawSkipped(surface) {}
    /**
     */

  }, {
    key: "onSurfaceDrawStart",
    value: function onSurfaceDrawStart(surface) {}
    /**
     * if returns true, it prevent a throw to happen from the request animation frame loop (or from a surface.flush() call).
     */

  }, {
    key: "onSurfaceDrawError",
    value: function onSurfaceDrawError(e) {
      return false;
    }
    /**
     */

  }, {
    key: "onSurfaceDrawEnd",
    value: function onSurfaceDrawEnd(surface) {}
    /**
     */

  }, {
    key: "onNodeDrawSkipped",
    value: function onNodeDrawSkipped(node) {}
    /**
     */

  }, {
    key: "onNodeDrawStart",
    value: function onNodeDrawStart(node) {}
    /**
     */

  }, {
    key: "onNodeSyncDeps",
    value: function onNodeSyncDeps(node, additions, deletions) {}
    /**
     */

  }, {
    key: "onNodeDraw",
    value: function onNodeDraw(node, preparedUniforms) {}
    /**
     */

  }, {
    key: "onNodeDrawEnd",
    value: function onNodeDrawEnd(node) {}
  }]);

  return Visitor;
}();

exports.default = Visitor;